import React, { useEffect, useState } from "react";
import divider from "../../../../images/Vector 11.png";
import camera from "../../../../images/cameragreycolor.png";
import "./addproduct.scss";
import axios from "axios";
import arrow from "../../../../images/dropdown1.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";
import SellerNavigationComponent from "./SellerNavigationComponent";
import { useNavigate, useParams } from "react-router-dom";
const baseUrl = process.env.REACT_APP_BASEURL;
const ProductEdit = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [fullColor, setFullColor] = useState([]);
  const [fullVariation, setVariation] = useState([]);
  const [category, setSelectedCategory] = useState("");
  const [colors, setColors] = useState([]);
  const [attributes, setAttributes] = useState([]);
  const [allpickup, setAllpickup] = useState([]);
  const [selectedColor, setSelectedColor] = useState([]);
  const [subcategory, setSelectedSubcategory] = useState("");
  const [selectedAttribute1, setSelectedAttribute1] = useState([]);
  const [newsubcategory2, setnewSubcategory2] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [selectedArrays, setSelectedArray] = useState([]);
  const [warrenty, setWarrenty] = useState("");
  const [hsn, setHsn] = useState("");
  const [selectedNewsubcategory, setSelectedNewsubcategory] = useState("");
  const [subcategories, setSubcategories] = useState([]);
  const [newsubcategory, setnewSubcategory] = useState([]);
  const [newsubcategory1, setSelectedCategory1] = useState("");
  const [brands, setBrands] = useState([]);
  const [pickupvalue, setpickupvalue] = useState("");
  const [productName, setProductName] = useState("");
  const [price, setPrice] = useState("");
  const [price1, setPrice1] = useState("");
  const [stock, setStock] = useState("");
  const [color, setColor] = useState("");
  const [attribute, setAttribute] = useState("");
  const [sku, setSku] = useState("");
  const [gst, setGst] = useState("");
  const [weight, setWeight] = useState("");
  const [length, setLength] = useState("");
  const [breadth, setBreadth] = useState("");
  const [height, setHeight] = useState("");
  const [discount, setDiscount] = useState("");
  const [newBrand, setNewBrand] = useState("");
  const [description, setDescription] = useState("");
  const [specification, setSpecification] = useState("");
  const [selectedArrays1, setSelectedArray1] = useState([]);

  const state = useSelector((state) => state.sellers);
  const { sellerAuth } = state;
  console.log(sellerAuth, "auth");
  const [image, setImage] = useState("");
  const [image1, setImage1] = useState("");
  const [image2, setImage2] = useState("");
  const [image3, setImage3] = useState("");
  const [newData, setNewData] = useState({});

  const [delivarycharge, setDelivarycharge] = useState("");
  const [details, setDetails] = useState("");
  const [productData, setProductData] = useState({});
  const { id } = useParams();
  const [checkbox1, setCheckbox1] = useState(false);
  const [checkbox2, setCheckbox2] = useState(false);
  const [checkbox3, setCheckbox3] = useState(false);
  const [checkbox4, setCheckbox4] = useState(false);
  const [checkbox5, setCheckbox5] = useState(false);
  const [checkbox6, setCheckbox6] = useState(false);
  const [checkbox7, setCheckbox7] = useState(false);
  const [selectedValues2, setSelectedValues2] = useState("");
  const [selectedValues3, setSelectedValues3] = useState([]);
  const [selectedValues4, setSelectedValues4] = useState("");
  const [selectedValues5, setSelectedValues5] = useState("");
  const [selectedValues6, setSelectedValues6] = useState("");
  const [selectedValues7, setSelectedValues7] = useState("");
  const [selectedValues8, setSelectedValues8] = useState("");
  const [selectedValues9, setSelectedValues9] = useState("");
  const [selectedValues10, setSelectedValues10] = useState("");
  const [selectedValues11, setSelectedValues11] = useState("");
  const [selectedValues12, setSelectedValues12] = useState("");
  const [selectedValues13, setSelectedValues13] = useState("");
  const [selectedValues14, setSelectedValues14] = useState("");
  const [selectedValues15, setSelectedValues15] = useState("");
  const [selectedValues1, setSelectedValues1] = useState("");

const navigate=useNavigate();
console.log(productData,'productData');
  const fetchProductData = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/Ecomproduct/${id}`);
      setProductData(response.data);
      console.log(response.data,'data');
      setNewData(response.data);
    } catch (error) {
      console.error("Failed to fetch product data", error);
    }
  };
  useEffect(() => {
    // Fetch the product data
    fetchProductData();
  }, [id]);
  console.log(productData, "productData");
  useEffect(() => {
    const fetchBrands = async () => {
      const response = await axios.get(`${baseUrl}/api/brand`);
      setBrands(response.data);
      console.log(response.data, "rrr");
      if (response.data.length > 0) {
        setNewBrand(response.data[0]._id);
      }
    };
    fetchBrands();
  }, []);
  const handleInputChange = (e) => {
    const { name, value, type,checked } = e.target;
    const newValue = type === 'checkbox' ? checked : value;

    setNewData((prevData) => ({ ...prevData, [name]: newValue }));
  };
  const handleInputChange0 = (attributeId, value) => {
    setSelectedValues1({
      attributeId:attributeId,
      value:value
    })

  };
  const handleInputChange1 = (attributeId, value) => {
    setSelectedValues3({
      attributeId:attributeId,
      value:value
    })
console.log(selectedValues3,'selectedvalue3');
// setSelectedArray([selectedValues1,selectedValues3])
// console.log(selectedArrays,'selectedArrays');
  };
  const handleInputChange2 = (attributeId, value) => {
    setSelectedValues5({
      attributeId:attributeId,
      value:value
    })
console.log(selectedValues3,'selectedvalue3');

  };
  const handleInputChange3 = (attributeId, value) => {
    setSelectedValues7({
      attributeId:attributeId,
      value:value
    })
console.log(selectedValues3,'selectedvalue3');
// setSelectedArray([selectedValues1,selectedValues3])
// console.log(selectedArrays,'selectedArrays');
  };
  const handleInputChange4 = (attributeId, value) => {
    setSelectedValues9({
      attributeId:attributeId,
      value:value
    })
console.log(selectedValues3,'selectedvalue3');

  };
  const handleInputChange5 = (attributeId, value) => {
    setSelectedValues11({
      attributeId:attributeId,
      value:value
    })
console.log(selectedValues3,'selectedvalue3');

  };
  const handleInputChange6 = (attributeId, value) => {
    setSelectedValues13({
      attributeId:attributeId,
      value:value
    })
console.log(selectedValues3,'selectedvalue3');

  };
  const handleInputChange7 = (attributeId, value) => {
    setSelectedValues15({
      attributeId:attributeId,
      value:value
    })
console.log(selectedValues3,'selectedvalue3');

  };
  useEffect(() => {
    const fetchColors = async () => {
      const response = await axios.get(`${baseUrl}/api/color/`);
      setColors(response.data);
    };
    fetchColors();
  }, []);
  useEffect(() => {
    const fetchAttributes = async () => {
      const response = await axios.get(`${baseUrl}/api/attribute/all`);
      setAttributes(response.data);
    };
    fetchAttributes();
  }, []);
  useEffect(() => {
    const fetchPickuplocations = async () => {
      const response = await axios.get(
        `${baseUrl}/api/order/allpickuplocation`
      );

      setAllpickup(response.data);
    };
    fetchPickuplocations();
  }, []);
  const firstValue = allpickup[0];
  const secondValue = allpickup[1];
  const thirdValue = allpickup[2];
  const fourthValue = allpickup[3];


  useEffect(() => {
    const fetchDetails = async () => {
      const response = await axios.post(
        `${baseUrl}/api/reseller/singleuserdetail`,
        {
          reseller: sellerAuth?._id,
        }
      );
      setDetails(response.data);
    };
    fetchDetails();
  }, []);
  console.log(details, "11");
  useEffect(() => {
    const fetchCategories = async () => {
      const response = await axios.get(`${baseUrl}/api/Ecom/category`);
      setCategories(response.data);
      setSelectedCategory(response.data[0]?._id); // set the first category as default
      if (response.data.length > 0) {
        setCategoryId(response.data[0]._id);
      }
    };
    fetchCategories();
  }, []);
  const fetchSubcategories = async () => {
    const response = await axios.get(
      `${baseUrl}/api/Ecom/category/${categoryId}/subcategories`
    );
    console.log(response.data, "pppppppp");
    setSubcategories(response.data);
    if (response.data.length > 0) {
      setSelectedSubcategory(response.data[0]._id);
    }
  };
  useEffect(() => {
    if (categoryId) {
      fetchSubcategories();
    }
  }, [categoryId]);
  const handleCheckBoxChange = (event) => {
    const selectedOptionId = event.target.value;
    const isChecked = event.target.checked;

    // Add or remove the selected option from the state based on the checkbox status
    if (isChecked) {
      setSelectedAttribute1((prevSelected) => [
        ...prevSelected,
        selectedOptionId,
      ]);
    } else {
      setSelectedAttribute1((prevSelected) =>
        prevSelected.filter((id) => id !== selectedOptionId)
      );
    }
  };
  const fetchSubcategories1 = async () => {
    const response = await axios.get(
      `${baseUrl}/api/Ecomsubcategory/${subcategory}/newsubcategories`
    );
    console.log(response.data, "qq");
    setnewSubcategory2(response.data);
    if (response.data.length > 0) {
      setSelectedNewsubcategory(response.data[0]._id);
    }
  };
  useEffect(() => {
    if (subcategory) {
      fetchSubcategories1();
    }
  }, [subcategory]);
  const handleCheckBoxChange1 = (event) => {
    const selectedOptionId = event.target.value;
    const isChecked = event.target.checked;

    // Add or remove the selected option from the state based on the checkbox status
    if (isChecked) {
      setSelectedColor((prevSelected) => [...prevSelected, selectedOptionId]);
    } else {
      setSelectedColor((prevSelected) =>
        prevSelected.filter((id) => id !== selectedOptionId)
      );
    }
  };
  const handlenewsubCategoryChange = (event) => {
    setSelectedCategory1(event.target.value);
  };
  const handleStatusChange = async (value) => {
    console.log(value, "valueee");
    setpickupvalue(value);
  };
  const handleCategoryChange = async (event) => {
    setSelectedCategory(event.target.value);

    console.log(event.target.value, "qqq");
    const response = await axios.get(
      `${baseUrl}/api/Ecom/category/${event.target.value}/subcategories`
    );
    console.log(response.data, "ooo");
    setSubcategories(response.data);
    if (response.data.length > 0) {
      setSelectedSubcategory(response.data[0]._id);
    }
  };
  const handlesubCategoryChange = (event) => {
    setSelectedSubcategory(event.target.value);
    const fetchsubcategory = async () => {
      // console.log(event.target.value, "2222");
      const response = await axios.get(
        `${baseUrl}/api/Ecomsubcategory/${event.target.value}/newsubcategories`
      );
      console.log(response.data, "new");
      return setnewSubcategory(response.data);
    };
    fetchsubcategory();
  };
  const handleSubmit1 = async() => {
    try {
      setSelectedArray1([selectedValues1,selectedValues3,selectedValues5,selectedValues7,selectedValues9,selectedValues11,selectedValues13,selectedValues15])

      console.log("hhhhhAFSD");
      const allColors = selectedColor?.map((item) => ({
        colorName: item,
        // image: image2,
      }));
      setFullColor(allColors);
      console.log(allColors, "ggggg");
      const variationObject = {
        attributes: selectedArrays,
        colors: allColors,
      };
      setVariation(variationObject);
      console.log(variationObject, "variationObject");
      toast.success("variations added");
      console.log(fullVariation, "lll");
      const response = await axios.put(
        `${baseUrl}/api/Ecomproduct/attributeedit/`,{
          attributes: selectedArrays1,
          productId:id,
          ecolors:selectedColor,
        }
      );
      console.log(response?.data,'oooo');
    } catch (e) {
      console.log(e);
    }
  };
  console.log(fullVariation, "lll");
  const handlebrandChange = (event) => {
    console.log(event.target.value, "ppp");
    setNewBrand(event.target.value);
  };

  const [fee, setFee] = useState("");
  const getCurrentDate = () => {
    const options = {
      weekday: "short",
      day: "numeric",
      month: "long",
      year: "numeric",
    };
    const currentDate = new Date().toLocaleDateString(undefined, options);
    return currentDate;
  };
  const handleClick = () => {
    console.log("click");



    const fetchsubcategory = async () => {
      const response = await axios.post(`${baseUrl}/api/fee/withprice`, {
        sellerPrice: newData.sellerPrice || productData.sellerPrice,
        weight: newData.weight || productData.weight,
        Ecomdiscount: newData.Ecomdiscount || productData.Ecomdiscount,
        deliveryCharge: newData.deliveryCharge || productData.deliveryCharge,
        Ecomnewsubcategory:
        newData.newsubcategory || productData.newsubcategory,

        Ecomsubcategory: newData.subcategory || productData.subcategory,
        price: newData.Ecomprice|| productData.Ecomprice,
        weight: newData.weight||productData?.weight,
        gst: newData.gst||productData?.gst,
        Ecomdiscount:newData.Ecomdiscount||productData?.Ecomdiscount,
      });
      console.log(response.data, "new");
      newData.sellingPrice = response.data.grandTotal;
      return setFee(response.data);
    };

    fetchsubcategory();
  };
console.log(newData,'fee');
  const [showHi, setShowHi] = useState(false);
    const handleClick1 = () => {
      setShowHi(!showHi);
    };
    const handleFormSubmit = async (e) => {
        e.preventDefault();
    
        try {
          const response = await axios.put(
            `${baseUrl}/api/Ecomproduct/${id}`,
            newData
          );
          console.log("Product updated:", response.data);
          // navigate(`/allproducts/${productData?.reseller?._id}`);

          navigate("/productlist");
        } catch (error) {
          console.error("Failed to update product", error);
        }
      };
  return (
    <div>
      <ToastContainer />
      <div style={{ display: "flex" }}>
        <SellerNavigationComponent />
        <img src={divider} className="divider" />
        <div>
          <form onSubmit={handleFormSubmit}>
            <p className="welcometext">Welcome, {details[0]?.Fullname}</p>
            <p className="todaysdate">{getCurrentDate()}</p>
            <p className="addproductmaintext">Edit Product</p>
            <p className="productinformationmaintext">Product Information</p>
            <div style={{ display: "flex" ,alignItems:"center"}}>
              <div>
                <p className="productnamemaintext">Product Name</p>
                <input
                  className="productnameinput"
                  id="productName"
                  name="EcomproductName"
                  value={newData.EcomproductName}
                  placeholder={productData.EcomproductName}
                  onChange={handleInputChange}
                />
              </div>
              <div className="brandmaindivtwo">
                <p className="productcategorymaintext">Select Brand</p>
                <select
                  id="brand"
                  className="productcategoryinput"
                  name="brand"
                  value={newBrand}
                  onChange={handlebrandChange}
                >
                  {brands?.map((obj) => (
                    <option key={obj._id} value={obj._id}>
                      {obj?.brand}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <p className="productcategorymaintexttwo">
                  Select Pickup location
                </p>
                <select
                  id="seller"
                  className="productcategoryinput"
                  name="pickupaddress"
                  onChange={(event) => handleStatusChange(event.target.value)}
                >
                  <>
                    <option>{firstValue}</option>
                    <option>{secondValue}</option>
                    <option>{thirdValue}</option>
                    <option>{fourthValue}</option>
                  </>
                </select>
              </div>
            </div>
            <div style={{ display: "flex" ,alignItems:"center"}}>
            <div>
                    <p className="productcategorymaintext">Product Category</p>
                    <select
                      name="Ecomcategory"
                      value={newData?.Ecomcategory || productData?.Ecomcategory}
                      onChange={handleCategoryChange}
                      className="productcategoryinput"
                    >
                      <option value="">Select category</option>
                      {categories.map((category) => (
                        <option key={category?._id} value={category?._id}>
                          {category.Ecomcategory}
                        </option>
                      ))}
                    </select>
                  </div>
              <div>
                <p className="productwarrentydetails">
                  Product Warranty details
                </p>
                <input
                  className="productwarrentyinput"
                  id="warrenty"
                  name="warrenty"
                  value={newData.warrenty}
                  placeholder={productData.warrenty}
                  onChange={handleInputChange}
                />
              </div>
              <div>
                <p className="productwarrentydetails">HSN</p>
                <input
                  className="productwarrentyinput"
                  id="warrenty"
                  name="hsn"
                  value={newData.hsn}
                  placeholder={productData.hsn}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div style={{ display: "flex",alignItems:"center" }}>
            <div>
                    <p className="productcategorymaintext">
                      Product Subcategory
                    </p>
                    <select
                      id="subcategory"
                      className="productcategoryinput"
                      name="subcategory"
                      value={subcategory}
                      onChange={handlesubCategoryChange}
                    >
                      <option>Select subcategory</option>
                      {subcategories.map((subcategory) => (
                        <option key={subcategory._id} value={subcategory._id}>
                          {subcategory.Ecomsubcategory}
                        </option>
                      ))}
                    </select>
                  </div>
              <div>
                <p className="productweight">Breadth</p>
                <input
                  className="productcategoryinput"
                  id="weight"
                  name="breadth"
                  value={newData.breadth}
                  placeholder={productData.breadth}
                  onChange={handleInputChange}
                />
                <p className="productweighttext">Enter Your Product Breadth</p>
              </div>

              <div>
                <p className="productweight">Discount</p>
                <input
                  className="productcategoryinput"
                  id="weight"
                  name="Ecomdiscount"
                  value={newData.Ecomdiscount}
                  placeholder={productData.Ecomdiscount}
                  onChange={handleInputChange}
                />
                <p className="productweighttext">Enter Your Product discount</p>
              </div>
            </div>
            <div style={{ display: "flex" ,alignItems:"center" }}>
              <div>
                <p className="productcategorymaintext">
                  Product NewSubcategory
                </p>
                <select
                  id="newsubcategory1"
                  className="productcategoryinput"
                  name="newcategory"
                  value={newsubcategory1}
                  onChange={handlenewsubCategoryChange}
                >
                  {newsubcategory2?.map((obj) => (
                    <option key={obj._id} value={obj._id}>
                      {obj?.Ecomnewsubcategory}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <p className="skutext">GST</p>
                <input
                  className="skuinput"
                  id="sku"
                  name="gst"
                  value={newData.gst}
                  placeholder={productData.gst}
                  onChange={handleInputChange}
                />
              </div>
              <div>
                <p className="delivary">Delivery Charge</p>
                <input
                 className="productnameinput"
                 id="deliveryCharge"
                 type="text"
                 name="deliveryCharge"
                  value={newData.deliveryCharge}
                  placeholder={productData.deliveryCharge}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            {/* <input className="productcategoryinput" /> */}
            <p className="productdetailtext">Product Detail</p>
            <div style={{ display: "flex" ,alignItems:"center" }}>
              <div>
                <p className="mrptext">MRP</p>
                <input
                  className="mrpinput"
                  id="price"
                  name="mrp"
                  value={newData.mrp}
                  placeholder={productData.mrp}
                  onChange={handleInputChange}
                />
                <p className="maximumretailprice">
                  Your product Maximum Retail Price
                </p>
              </div>
              <div>
                <p className="pricemaintext">Seller Price
</p>
                <input
                 className="productnameinput"
                 id="sellerPrice"
                 type="text"
                 name="sellerPrice"
                  value={newData.sellerPrice}
                  placeholder={productData.sellerPrice}
                  onChange={handleInputChange}
                />
                <p className="yoursellingpricetext">Set your selling price </p>
              </div>

              <div>
                <p className="skuintext">SKU</p>
                <input
                  className="skuinput"
                  id="sku"
                  name="sku"
                  value={newData.sku}
                  placeholder={productData.sku}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div style={{ display: "flex" ,alignItems:"center" }}>
              <div>
                <p className="productweight">Weight</p>
                <input
                  className="productcategoryinput"
                  id="weight"
                  name="weight"
                  value={newData.weight}
                  placeholder={productData.weight}
                  onChange={handleInputChange}
                />
                <p className="productweighttext">Enter Your Product Weight</p>
              </div>
              <div>
                <p className="productweight">Length</p>
                <input
                  className="productcategoryinput"
                  id="weight"
                  name="length"
                  value={newData.length}
                  placeholder={productData.length}
                  onChange={handleInputChange}
                />
                <p className="productweighttext">Enter Your Product Weight</p>
              </div>
              <div>
                <p className="productweight">Height</p>
                <input
                  className="productcategoryinput"
                  id="height"
                  type="text"
                  name="height"
                  value={newData.height}
                  placeholder={productData.height}
                  onChange={handleInputChange}
                />
                <p className="productweighttext">Enter Your Product Weight</p>
              </div>
            </div>
            <div style={{ display: "flex" ,alignItems:"center" }}>
            <div>
                <p className="pricemaintextoneedit">Maximum Order Quantity</p>
                <input
                  className="yoursellerpriceinputoneedit"
                  id="maxorderquantity"
                  type="Number"
                  name="maxQuantity"
                  value={newData.maxQuantity}
                  onChange={handleInputChange}
                  placeholder={productData.maxQuantity}

                />
              </div>
              <div>
                <p className="mrptext">Shipping Fee</p>
                <input
                  className="mrpinput"
                  id="shippingFee"
                  type="Number"
                  name="shippingFee"
                  value={newData.shippingFee}
                  onChange={handleInputChange}
                  placeholder={productData.shippingFee}
                  />
              </div>
              <div style={{display:'flex'}}>
                <p className="productwarrentydetails" style={{marginTop:"20%"}}>COD Available?</p>
                <input
                style={{marginLeft:'22%',marginTop:'10px'}}
                type="checkbox"
                name="codAvailable"
                id="sortorder"
                  checked={newData.codAvailable}
                  onChange={handleInputChange}
                />
              </div>
</div>


            <div style={{ display: "flex" ,alignItems:"center" }}>
              <div>
                <p className="stocknametext">Stock</p>
                <input
                  id="stock"
                  className="stockinput"
                  name="Ecomstock"
                  value={newData.Ecomstock}
                  placeholder={productData.Ecomstock}
                  onChange={handleInputChange}
                />
                <p className="itemstocknotforsale">
                  item with 0 stock will automatically set to be "Not for Sale”
                </p>
              </div>
              <div className="onstarapiceandchargesedit">
                <p>Onstara Price & Charges</p>
                <input
                name="sellingPrice"
                  className="priceandchargesinput"
                  onChange={handleInputChange}
                  value={newData.sellingPrice}
                  placeholder={productData.sellingPrice}
                />
              </div>
              <div
                className="viewchargesdivedit"
                onClick={handleClick}
                style={{ display: "flex" ,alignItems:"center"}}
              >
                <p className="viewchargestext">View Charges</p>
                <img
                  src={arrow}
                  className="arrowimage"
                    onClick={handleClick1}
                />
                {/* <p onClick={handleClick1}>.</p> */}
              </div>
              {showHi && (
                <>
                  <div className="viewchargesonclickbox">
                  
<p>Onstara Fees:₹{fee?.onstarafee1}</p>
                  
                    <p>Fixed Fee:₹{fee?.fixedfee1}</p>
                    {/* <p>Shipping:₹{fee?.shippingfee1}</p> */}
                    {!newData.deliveryCharge ? (
                      <p>Shipping: Free</p>
                    ) : (
                      <p>Shipping: ₹{newData.deliveryCharge}</p>
                    )}

                    <p>AD Fees:Free</p>
                    <p>Packing Fee:Free</p>
                  </div>
                </>
              )}
            </div>
            {/* <div style={{ display: "flex" }}>
              <div className="variationdiv">
                <p className="variationtext">Variation</p>
                <p className="colors">Colors</p>
           
                <div class="custom-select-wrapper">
                  <div class="custom-select">
                    <div class="custom-options">
                      {colors?.map((item, index) => (
                        <label key={item?._id} class="custom-option">
                          <input
                            type="checkbox"
                            name="selectedOptions"
                            value={item?._id}
                            checked={selectedColor?.includes(item?._id)}
                            onChange={handleCheckBoxChange1}
                          />
                          {item?.Ecomcolor}
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
                <p className="colors">Attributes</p>
                <div class="custom-select-wrapper">
                  <div class="custom-select">
                    <div class="custom-options">
                      {attributes?.map((item, index) => (
                        <label key={item?._id} class="custom-option">
                          <input
                            type="checkbox"
                            name="selectedOptions"
                            value={item?._id}
                            checked={selectedAttribute1.includes(item?._id)}
                            onChange={handleCheckBoxChange}
                          />
                          {item?.Ecomattribute}
                        </label>
                      ))}
                    </div>
                  </div>
                  <div class="selected-attributes1">
                    {Array.isArray(selectedAttribute1) &&
                      selectedAttribute1.slice(0, 2).map((attributeId) => (
                        <>
                          <input
                            type="text"
                            key={attributeId}
                            value={selectedValues[attributeId] || ""}
                            onChange={(e) =>
                              handleInputChange(attributeId, e.target.value)
                            }
                          />
                        </>
                      ))}
                  </div>
                
                  <div onClick={handleSubmit1} className="confirmbutton">
                    <p className="confirmtext">Confirm</p>
                  </div>
                </div>
              </div>
            </div> */}
              <div className="variationdiv">
                <p className="variationtext">Variation</p>
                <p className="colors">Colors</p>
                {/* <select
                  className="productcategoryinput"
                  id="subcategory"
                  name="subcategory"
                  value={selectedAttribute}
                  onChange={handleattributeChange}
                  multiple
                >
                  {colors?.map((item, index) => (
                    <option key={item?._id} value={item?._id}>
                      {item?.Ecomcolor}
                    </option>
                  ))}
                </select> */}
                <form onSubmit={handleSubmit1}>
                  <div class="custom-select-wrapper">
                    <div class="custom-select">
                      <div class="custom-options">
                        {colors?.map((item, index) => (
                          <label key={item?._id} class="custom-option">
                            <input
                              type="checkbox"
                              name="selectedOptions"
                              value={item?._id}
                              checked={selectedColor?.includes(item?._id)}
                              onChange={handleCheckBoxChange1}
                            />
                            {item?.Ecomcolor}
                          </label>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* {colors?.map((item, index) => (
                  <>
                    <input
                      type="file"
                      placeholder="Enter image"
                      id="image1"
                      name="image1"
                      enctype="multipart/form-data"
                      value={image2}
                      onChange={(event) => setImage2(event.target.value)}
                    />
                    <p className="attributenames">{item?.Ecomcolor}</p>
                  </>
                ))} */}
                  <p className="colors">Attributes</p>

                  {/* <select
                  className="productcategoryinput"
                  id="subcategory"
                  name="subcategory"
                  value={selectedAttribute}
                  onChange={handleattributeChange}
                >
                  {attributes?.map((item, index) => (
                    <option key={item?._id} value={item?._id}>
                      {item?.Ecomattribute}
                    </option>
                  ))}
                </select> */}
                  <div class="custom-select-wrapper">
                    <div class="custom-select">
                      <div class="custom-options">
                        {attributes?.map((item, index) => (
                          <label key={item?._id} class="custom-option">
                            <input
                              type="checkbox"
                              name="selectedOptions"
                              value={item?._id}
                              checked={selectedAttribute1.includes(item?._id)}
                              onChange={handleCheckBoxChange}
                            />
                            {item?.Ecomattribute}
                          </label>
                        ))}
                      </div>
                    </div>
                    <div class="selected-attributes1">
                      {Array.isArray(selectedAttribute1) &&
                        selectedAttribute1.slice(0, 2).map((attributeId) => (
                          <>
                            <div style={{ flexDirection: "column" }}>
                            <input
                              type="text"
                              required
                              // key={attributeId}
                              value={selectedValues}
                              onChange={(e) => {
                                handleInputChange0(attributeId, e.target.value);
                                // Call the second function here
                                setSelectedValues(e.target.value);
                              }}
                            />
                            <input
                              type="checkbox"
                              checked={checkbox1}
                              onChange={(event) =>
                                setCheckbox1(event.target.checked)
                              }
                            />
                              {checkbox1 && (
                                <>
                                  <input
                                    type="text"
                                    required
                                    checked={checkbox2}
                                    value={selectedValues2}
                              onChange={(e) => {
                                handleInputChange1(attributeId, e.target.value);
                                // Call the second function here
                                setSelectedValues2(e.target.value);
                              }}
                                  />
                                  <input
                                    type="checkbox"
                                    checked={checkbox2}
                                    onChange={(event) =>
                                      setCheckbox2(event.target.checked)
                                    }
                                  />
                                </>
                              )}

                              {checkbox2 && (
                                <>
                                  <input
                                    type="text"
                                    required
                                    checked={checkbox3}
                                    value={selectedValues4}
                              onChange={(e) => {
                                handleInputChange2(attributeId, e.target.value);
                                setSelectedValues4(e.target.value);
                              }}
                                  />
                                  <input
                                    type="checkbox"
                                    checked={checkbox3}
                                    onChange={(event) =>
                                      setCheckbox3(event.target.checked)
                                    }
                                  />
                                </>
                              )}
                              {checkbox3 && (
                                <>
                                  <input
                                    type="text"
                                    required
                                    checked={checkbox4}
                                    value={selectedValues6}
                                    onChange={(e) => {
                                      handleInputChange3(attributeId, e.target.value);
                                      setSelectedValues6(e.target.value);
                                    }}
                                  />
                                  <input
                                    type="checkbox"
                                    checked={checkbox4}
                                    onChange={(event) =>
                                      setCheckbox4(event.target.checked)
                                    }
                                  />
                                </>
                              )}



{checkbox4 && (
                                <>
                                  <input
                                    type="text"
                                    required
                                    checked={checkbox5}
                                    value={selectedValues8}
                                    onChange={(e) => {
                                      handleInputChange4(attributeId, e.target.value);
                                      setSelectedValues8(e.target.value);
                                    }}
                                  />
                                  <input
                                    type="checkbox"
                                    checked={checkbox5}
                                    onChange={(event) =>
                                      setCheckbox5(event.target.checked)
                                    }
                                  />
                                </>
                              )}
                              {checkbox5 && (
                                <>
                                  <input
                                    type="text"
                                    required
                                    checked={checkbox6}
                                    value={selectedValues10}
                                    onChange={(e) => {
                                      handleInputChange5(attributeId, e.target.value);
                                      setSelectedValues10(e.target.value);
                                    }}
                                  />
                                  <input
                                    type="checkbox"
                                    checked={checkbox6}
                                    onChange={(event) =>
                                      setCheckbox6(event.target.checked)
                                    }
                                  />
                                </>
                              )}


{checkbox6 && (
                                <>
                                  <input
                                    type="text"
                                    required
                                    checked={checkbox7}
                                    value={selectedValues12}
                                    onChange={(e) => {
                                      handleInputChange6(attributeId, e.target.value);
                                      setSelectedValues12(e.target.value);
                                    }}
                                  />
                                  <input
                                    type="checkbox"
                                    checked={checkbox7}
                                    onChange={(event) =>
                                      setCheckbox7(event.target.checked)
                                    }
                                  />
                                </>
                              )}


{checkbox7 && (
                                <>
                                  <input
                                    type="text"
                                    required
                                    checked={checkbox7}
                                    value={selectedValues14}
                                    onChange={(e) => {
                                      handleInputChange7(attributeId, e.target.value);
                                      setSelectedValues14(e.target.value);
                                    }}
                                  />
                                  <input
                                    type="checkbox"
                                    checked={checkbox7}
                                    onChange={(event) =>
                                      setCheckbox7(event.target.checked)
                                    }
                                  />
                                </>
                              )}
                            </div>
                          </>
                        ))}
                    </div>
                    {/* <pre>
                    Selected Values: {JSON.stringify(selectedValues, null, 2)}
                  </pre> */}
                  </div>
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={handleSubmit1}
                    className="confirmbutton"
                  >
                    <p className="confirmtext">Confirm</p>
                  </div>
                  {/* </div> */}
                </form>
              </div>
            <div style={{ display: "flex" }}>
              <div>
                <p className="productdesciptiontext">Product Description</p>
                <textarea
                  id="description"
                  name="Ecomdescription"
                  value={newData.Ecomdescription}
                  onChange={handleInputChange}
                  className="productdesciptiontextinput"
                ></textarea>
              </div>

              <div>
                <p className="productdesciptiontext">Product Specification</p>
                <textarea
                  className="productdesciptiontextinput"
                  id="specification"
                  placeholder={productData.specification}
                  name="specification"
                  value={newData.specification}
                  onChange={handleInputChange}
                ></textarea>
              </div>
            </div>
            <button 
            // onClick={()=>{navigate("/productlist")}}
            className="sellbutton" type="submit">
              Edit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ProductEdit;
